import { debounce } from 'lodash';

export default class BrixTabMenu {
  static init(...parameters) {
    return new BrixTabMenu(...parameters);
  }

  constructor(block) {
    this.tabMenuWrapper = block.querySelector('.tab-menu-wrapper');
    this.tabMenu = block.querySelector('.tab-menu');
    this.tabMenu.addEventListener('scroll', debounce(() => { this.toggleFadeVisibility(); }, 10));
    window.addEventListener('resize', debounce(() => { this.toggleFadeVisibility(); }), 300);
    this.toggleFadeVisibility();

    if (!block.classList.contains('-no-reload')) {
      this.currentMenuLink = block.querySelector('.menu-link.-current');
      this.centerCurrentMenuItem(this.currentMenuLink);
    } else {
      this.menuButtons = block.querySelectorAll('.menu-button');
      this.tabs = block.querySelectorAll('.tab');

      [...this.menuButtons].forEach((menuButton) => {
        menuButton.addEventListener('click', (event) => this.handleMenuClick(event));

        if (window.location.hash === `#${menuButton.dataset.hash}`) {
          this.setCurrent(menuButton.dataset);
        }
      });

      window.addEventListener('hashchange', () => {
        [...this.menuButtons].forEach((menuButton) => {
          if (window.location.hash === `#${menuButton.dataset.hash}`) {
            this.setCurrent(menuButton.dataset);
          }
        });
      });
    }
  }

  centerCurrentMenuItem(item) {
    this.tabMenu.scrollLeft = item.getBoundingClientRect().left;
  }

  handleMenuClick(event) {
    this.setCurrent(event.target.dataset);
  }

  setCurrent(dataset) {
    if (window.location.hash !== dataset.hash) {
      window.location.hash = dataset.hash;
    } else {
      window.location.hash = '';
    }

    [...this.menuButtons].forEach((menuButton) => {
      if (menuButton.dataset.id === dataset.id) {
        menuButton.classList.add('-current');
        this.centerCurrentMenuItem(menuButton);
      } else {
        menuButton.classList.remove('-current');
      }
    });

    [...this.tabs].forEach((tab) => {
      if (tab.dataset.id === dataset.id) {
        tab.classList.add('-current');
      } else {
        tab.classList.remove('-current');
      }
    });
  }

  toggleFadeVisibility() {
    const wrapperClassList = this.tabMenuWrapper.classList;

    // Show left fade area
    if (this.tabMenu.scrollLeft > 1 && !wrapperClassList.contains('-left-fade')) {
      wrapperClassList.add('-left-fade');
    }

    // Hide left fade area
    if (this.tabMenu.scrollLeft < 1 && wrapperClassList.contains('-left-fade')) {
      wrapperClassList.remove('-left-fade');
    }

    // Show right fade area
    if (this.tabMenu.scrollLeft > 1 && !wrapperClassList.contains('-right-fade')) {
      wrapperClassList.add('-right-fade');
    }

    // Show right fade area
    if (this.tabMenu.scrollLeft + this.tabMenu.offsetWidth
      <= this.tabMenu.scrollWidth && !wrapperClassList.contains('-right-fade')) {
      wrapperClassList.add('-right-fade');
    }

    // Hide right fade area
    if (this.tabMenu.scrollLeft + this.tabMenu.offsetWidth
      >= this.tabMenu.scrollWidth && wrapperClassList.contains('-right-fade')) {
      wrapperClassList.remove('-right-fade');
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-tab-menu', BrixTabMenu.init);
}
